export const getLogoCarouselSlidesToShow = (width, maxSlides = 6) => {
  if (!width) return 1;
  if (width <= 480) return 1;
  if (width <= 768) return 2;
  if (width <= 1200) return 3;
  if (width <= 1360) return 4;
  if (width <= 1580) return 5;
  return maxSlides;
};

export const baseLogoCarouselSettings = {
  dots: true,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  infinite: true,
  speed: 400,
  slidesToScroll: 1,
};
